import NProgress from "nprogress"
import axios from "axios"

const calculatePercentage = (loaded: number, total: number) =>
	Math.floor(loaded * 1.0) / total

const setupUpdateProgress = () => {
	axios.defaults.onDownloadProgress = (e) => {
		const percentage = calculatePercentage(e.loaded, e.total)
		NProgress.set(percentage)
	}
}

const setupStartProgress = () => {
	axios.interceptors.request.use((request) => {
		NProgress.start()
		return request
	})
}

const setupStopProgress = () => {
	axios.interceptors.response.use((response) => {
		NProgress.done(true)
		return response
	})
}

export function load(config?: Partial<NProgress.NProgressOptions>) {
	NProgress.configure(config || {})
	setupStartProgress()
	setupUpdateProgress()
	setupStopProgress()
}
